// Adapter — the rule moved to `@heidi/workspace`, name and module identity
// intact. `useMutateUpdateUser` is bound HERE rather than injected through
// `configureWorkspaceData`: only this delegate performs the three app reactions
// the headless core cannot, and design D7 bans putting them on that seam.
import { useMutateUpdateUser } from '@/hooks/mutation/useMutateUpdateUser';
import { useQueryUser } from '@/hooks/query/useQueryUser';
import { useMigrateTranscriptDefaultTabToNote as useMigrateTranscriptDefaultTabToNoteCore } from '@heidi/workspace';

export const useMigrateTranscriptDefaultTabToNote = () => {
  const { data: defaultSessionTab } = useQueryUser(
    (select) => select.session_settings?.default_new_session_tab
  );
  const { mutateAsync: updateUser } = useMutateUpdateUser();

  useMigrateTranscriptDefaultTabToNoteCore({ defaultSessionTab, updateUser });
};
